module.exports = __webpack_public_path__ + "static/Another-Birthday_mobile-aa6851d9a62677bd11a8954af6733283.webp";